module.exports = __webpack_public_path__ + "media/newstyle/images/word-message-es-3967f199c8ae3d40edc2cf2ee09df0cc.svg";